import Typography from 'components/Typography';
import RadioButton from 'components/Input/RadioButtonField';
import { Content } from './styles';
import { OptionProps } from './type';

const Option = (props: OptionProps) => {
  const { title, description, ...radioButtonProps } = props;

  return (
    <RadioButton.Field {...radioButtonProps}>
      <Content>
        <Typography variant='label' color='strong'>
          {title}
        </Typography>
        <Typography variant='body' color='weak' size='sm'>
          {description}
        </Typography>
      </Content>
    </RadioButton.Field>
  );
};
export default Option;
